module.exports = __webpack_public_path__ + "img/eye-round-roast-with-vegetables.1aea77da.jpg";